<template>
    <SimpleWidgetPageWithSwitcher
        v-if="widgetPage"
        :widget-page-id="widgetPageId"
        :widget-type="widgetPage?.type"
        :dependencies="dependencies"
        :switcher="widgetPage?.switcher"
        :placeholder-item-count="5"
        @widget-page-id-change="emit('widgetPageIdChange', $event)"
    >
        <template #placeholder-item>
            <div class="py-5">
                <UIGhostLoader
                    type="h3"
                    class="mb-3"
                    no-margin
                />
                <UIGhostLoader
                    type="p"
                    class="max-w-2/3"
                    no-margin
                />
            </div>
        </template>
        <StudentAcademicReportsItem
            v-for="(item, index) in displayItems"
            :key="index"
            :item="item"
            :show-icons="false"
            :is-last="index === displayItems.length - 1"
        />
    </SimpleWidgetPageWithSwitcher>
</template>

<script setup>
    import { useWidgetsStore } from '@/stores/widgets'
    import { useWidgetPagesStore } from '@/stores/widgetPages'
    import StudentAcademicReportsItem
        from '@/components/next-gen/widgets/student-academic-reports/StudentAcademicReportsItem.vue'

    const emit = defineEmits(['widgetPageIdChange'])

    const props = defineProps({
        widgetPageId: String,
    })

    const widgetsStore = useWidgetsStore()
    const widgetPagesStore = useWidgetPagesStore()

    const { widgetPages } = storeToRefs(widgetPagesStore)

    const widgetPageMetadata = computed(() => widgetPages.value?.[props.widgetPageId])
    const widgetPage = computed(() => widgetPageMetadata.value?.data)

    const dependencies = computed(() => {
        return widgetPage.value?.dependencies ?? []
    })

    const displayItems = computed(() => {
        return widgetsStore.items(widgetPage.value?.type, dependencies.value)
    })
</script>
